import React, { useEffect, useState } from "react";
import { MdInfo, MdAutoAwesome, MdLightbulb } from 'react-icons/md';
import { APP_BASE_URL } from '../config/api';

const ReportDetails = ({ selectedKey, selectedValue, recordContext }) => {
  // Add validation
  const isValidData = selectedKey && selectedValue;

  const [explanation, setExplanation] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (!isValidData) return;

    console.log('🔍 ReportDetails useEffect triggered:', { selectedKey, selectedValue, recordContext });

    setIsLoading(true);
    setExplanation("Analyzing...");

    // Prepare the request payload
    const payload = {
      key: selectedKey,
      value: selectedValue,
       context: {
         ...recordContext,
         recordType: selectedKey === 'description' ? 'violation' : 'record'
       }
    };

    console.log('📤 Sending request to /api/explain:', payload);

    fetch(`${APP_BASE_URL}/api/explain`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      credentials: 'include',
      body: JSON.stringify(payload)
    })
      .then(async (res) => {
        console.log('📥 Response received:', { ok: res.ok, status: res.status });
        if (!res.ok) {
          const errorData = await res.json();
          console.error('❌ Error response:', errorData);
          throw new Error(errorData.detail || 'Failed to generate explanation');
        }
        return res.json();
      })
      .then((data) => {
        console.log('✅ Explanation received:', data);
        setExplanation(data.explanation || 'No explanation available');
        setIsLoading(false);
      })
      .catch((err) => {
        console.error("❌ Error fetching explanation:", err);
        setExplanation("Unable to generate explanation at this time. Please try again later.");
        setIsLoading(false);
      });
  }, [selectedKey, selectedValue, recordContext]);

  return (
    <div className="h-full flex flex-col bg-white max-h-full overflow-hidden">
      {/* Fixed Header */}
      <div className="flex-shrink-0 px-4 py-4 border-b border-gray-200 bg-gradient-to-r from-gray-50 to-gray-100">
        <div className="flex items-center gap-2">
          <div className="w-7 h-7 rounded-lg bg-purple-500 flex items-center justify-center">
            <MdAutoAwesome className="text-white" size={16} />
          </div>
          <h2 className="text-sm font-semibold text-gray-800">Smart Insights</h2>
        </div>
      </div>

      {/* Scrollable Content Area - Key fix here */}
      <div className="flex-1 min-h-0 overflow-y-auto">
        <div className="p-4 space-y-4">
          {selectedKey ? (
            <>
              {/* Selected Information Card */}
              <div className="bg-gradient-to-br from-purple-50 to-purple-50/30 rounded-lg border border-purple-200 shadow-sm">
                <div className="px-4 py-3 border-b border-purple-200/50">
                  <div className="flex items-center gap-2">
                    <MdLightbulb className="text-purple-600" size={14} />
                    <span className="text-xs font-semibold text-purple-900 uppercase tracking-wider">
                      Selected Field
                    </span>
                  </div>
                </div>
                <div className="px-4 py-3">
                  {/* <div className="mb-2">
                    <span className="text-xs font-medium text-gray-600">Field:</span>
                    <span className="ml-2 text-xs font-semibold text-gray-800 capitalize">
                      {selectedKey.replace(/_/g, ' ')}
                    </span>
                  </div> */}
                  <div className="bg-white/60 rounded-md p-3 border border-purple-100">
                    <p className="text-xs text-gray-700 leading-relaxed break-words">
                      {typeof selectedValue === 'object'
                        ? JSON.stringify(selectedValue, null, 2)
                        : selectedValue}
                    </p>
                  </div>
                </div>
              </div>

              {/* AI Analysis Card */}
              <div className="bg-white rounded-lg border border-gray-200 shadow-sm">
                <div className="px-4 py-3 border-b border-gray-100">
                  <div className="flex items-center justify-between">
                    <div className="flex items-center gap-2">
                      <div className="w-6 h-6 rounded-md bg-gradient-to-br from-blue-500 to-purple-600 flex items-center justify-center">
                        <MdAutoAwesome className="text-white" size={12} />
                      </div>
                      <span className="text-xs font-semibold text-gray-700 uppercase tracking-wider">
                        AI Analysis
                      </span>
                    </div>
                    {isLoading && (
                      <div className="flex items-center gap-1.5">
                        <div className="w-1.5 h-1.5 bg-purple-500 rounded-full animate-pulse" />
                        <span className="text-xs text-purple-600 font-medium">
                          Analyzing...
                        </span>
                      </div>
                    )}
                  </div>
                </div>
                <div className="px-4 py-4">
                  <div className="bg-gray-50 rounded-lg p-4 border border-gray-100">
                    <div className="text-xs text-gray-700 leading-relaxed whitespace-pre-line break-words">
                      {explanation}
                    </div>
                  </div>
                </div>
              </div>

              {/* Context Information (if available) */}
              {/* {recordContext && (
                <div className="bg-blue-50 rounded-lg border border-blue-200 shadow-sm">
                  <div className="px-4 py-3 border-b border-blue-200/50">
                    <div className="flex items-center gap-2">
                      <MdInfo className="text-blue-600" size={14} />
                      <span className="text-xs font-semibold text-blue-900 uppercase tracking-wider">
                        Context
                      </span>
                    </div>
                  </div>
                  <div className="px-4 py-3">
                    <div className="grid gap-2">
                      {Object.entries(recordContext).map(([key, value]) => (
                        <div key={key} className="flex items-start gap-2">
                          <span className="text-xs font-medium text-blue-700 capitalize min-w-0 flex-shrink-0">
                            {key.replace(/_/g, ' ')}:
                          </span>
                          <span className="text-xs text-blue-800 min-w-0 break-words">
                            {typeof value === 'object' 
                              ? JSON.stringify(value, null, 2) 
                              : String(value)}
                          </span>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              )} */}
            </>
          ) : (
            // Enhanced Empty State
            <div className="flex flex-col items-center justify-center text-center px-6 py-8">
              <div className="bg-gradient-to-br from-purple-100 to-blue-100 rounded-full p-6 mb-4">
                <MdLightbulb className="text-purple-400" size={32} />
              </div>
              <h3 className="text-sm font-semibold text-gray-700 mb-2">
                No Data Selected
              </h3>
              <p className="text-xs text-gray-500 leading-relaxed max-w-[200px]">
                Click on any field or violation description to get AI-powered insights and explanations
              </p>
              <div className="mt-4 flex items-center gap-2 text-xs text-gray-400">
                <MdAutoAwesome size={14} />
                <span>Powered by AI Analysis</span>
              </div>
            </div>
          )}
        </div>
      </div>

      {/* Fixed Footer Disclaimer */}
      <div className="flex-shrink-0 px-4 py-3 bg-gray-50 border-t border-gray-200">
        <div className="flex items-start gap-2">
          <MdInfo className="text-gray-400 flex-shrink-0 mt-0.5" size={12} />
          <p className="text-xs text-gray-500 leading-relaxed">
            <span className="font-semibold">Disclaimer:</span> AI-generated insights should be independently verified for accuracy.
          </p>
        </div>
      </div>
    </div>
  );
};

export default ReportDetails;